module.exports = __webpack_public_path__ + "static/img/tupian@2x.11a599d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/deceitimages/v1/tupian@2x.png
// module id = gMO3
// module chunks = 23